import _classCallCheck from "/root/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/root/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/root/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/root/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/root/website/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable max-classes-per-file */
var BreakpointNotFoundError = /*#__PURE__*/function (_Error) {
  _inherits(BreakpointNotFoundError, _Error);

  var _super = _createSuper(BreakpointNotFoundError);

  function BreakpointNotFoundError(breakpoint) {
    _classCallCheck(this, BreakpointNotFoundError);

    return _super.call(this, "Breakpoint '" + breakpoint + "' not found");
  }

  return BreakpointNotFoundError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var NextBreakpointNotFoundError = /*#__PURE__*/function (_Error2) {
  _inherits(NextBreakpointNotFoundError, _Error2);

  var _super2 = _createSuper(NextBreakpointNotFoundError);

  function NextBreakpointNotFoundError(breakpoint) {
    _classCallCheck(this, NextBreakpointNotFoundError);

    return _super2.call(this, "Next breakpoint for '" + breakpoint + "' not found");
  }

  return NextBreakpointNotFoundError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

export { BreakpointNotFoundError, NextBreakpointNotFoundError };